import '@babel/polyfill'
import {IAcrElement} from "./interfaces/IAcrElement";

async function importModules () {

  const importedModulesNames = [];
  const pageModules = document.getElementsByClassName('js-module');

  for (let modulesIndex = 0; modulesIndex < pageModules.length; modulesIndex++) {
    const module: IAcrElement = pageModules[modulesIndex];

    const moduleName: string = module.dataset.module;

    if (!importedModulesNames.includes(moduleName) && !(window as any).Acr.hasOwnProperty(moduleName)){
      try {
        const importedModule = await import(`./components/${moduleName}/${moduleName}`);
        console.log(`Imported ${moduleName}`);
        (window as any).Acr[moduleName] = importedModule[moduleName];
        importedModulesNames.push(moduleName);
      } catch(e){
        console.error(`Unable to import ${moduleName}: ${e}`);
      }
    }
  }
}

importModules();
